exports.getDisplaySeconds = seconds => {
  const secondsLength = seconds.toString().length;
  if (secondsLength === 1) {
    return '0' + seconds;
  }
  return seconds;
};
